import { JSX } from "react";

export const ChevronLeft = (): JSX.Element => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0_7669_9990"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
            >
                <rect
                    x="24"
                    y="24"
                    width="24"
                    height="24"
                    transform="rotate(180 24 24)"
                    fill="#D9D9D9"
                />
            </mask>
            <g mask="url(#mask0_7669_9990)">
                <path
                    d="M10 6L16 12L10 18L8.6 16.6L13.2 12L8.6 7.4L10 6Z"
                    fill="#1D2D58"
                />
            </g>
        </svg>
    );
};
